import { useState } from 'react';
import { PopUp, Row } from '../../../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../../../components/Basic/Buttons';
import { DateInput, Input, Select } from '../../../../../components/Basic/Inputs';
import { H2 } from '../../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../../constans';
import { getDateSolid, getProviderNew, setDateSolid } from '../../../../../utils';
import styles from './styles.module.scss';

const ChangeBillPopUp = ({ bill, IP_LIST, providers, onChange = () => { }, close = () => { } }) => {

  const [newNumber, setNewNumber] = useState(bill.number)
  const [newIpId, setNewIpId] = useState(IP_LIST.find(ip => ip.value === bill.ip_id))
  const [newDateArrive, setNewDateArrive] = useState(bill.dates.arrive)
  const [newDokupInfo, setNewDokupInfo] = useState({ is: bill.dokup?.is, has: bill.dokup?.has })


  return (
    <PopUp style={{ width: '500px' }} close={close} clickOutside={false} className={styles.pop_up}>
      <H2>
        {`Изменить счет ${getProviderNew(bill.provider_id, providers)?.name} №${bill.number}`}
      </H2>
      <Row style={{ width: 'auto', marginTop: '20px' }}>
        <div style={{ margin: '0px 0px 10px 0px' }}>
          <DateInput
            width='120px'
            label="Дата прибытия"
            classNameCalendar={styles.date_input_calendar}
            value={getDateSolid(newDateArrive)}
            onChange={(v) => setNewDateArrive(setDateSolid(v))}
          />
        </div>
        <div style={{ margin: '0px 0px 0px 30px' }}>
          <Select
            greyLabel={true}
            label="ИП закупки"
            select={newIpId}
            list={IP_LIST}
            width='150px'
            valueFn={(v) => v.name}
            onSelect={(v) => {
              setNewIpId(v)
            }} />
        </div>
      </Row>

      <Row style={{ marginTop: '10px' }} >
        <div >
          <Input
            label='Номер счета'
            value={newNumber}
            onBlur={(v) => {
              setNewNumber(v);
            }}
            // disabled={isAutoFillBill}
            placeholder={'Номер счёта'}
          />
        </div>

        <Row style={{ margin: '25px 0 0 35px', }}>
          <CheckButton

            checked={newDokupInfo.has}
            onSelect={(v) => {
              setNewDokupInfo({ ...newDokupInfo, has: v })
            }}
          />
          <div style={{ color: '#000000c3', fontWeight: '500', margin: '5px 0 0 6px' }}>Есть докуп</div>
        </Row>

        <Row style={{ margin: '25px 0 0 20px', }}>

          <CheckButton
            // style={{ marginLeft: '5px', }}

            checked={newDokupInfo.is}
            onSelect={(v) => {
              setNewDokupInfo({ ...newDokupInfo, is: v })
            }}
          />
          <div style={{ color: '#000000c3', fontWeight: '500', margin: '5px 0 0 6px' }}>Докуп</div>
        </Row>
      </Row>

      <Row style={{ marginTop: '30px' }}>
        <Button type={TYPE_BUTTONS.BLUE} style={{ marginRight: '20px' }} onClick={() => {
          onChange({ billId: bill.id, newBill: { ...bill, number: newNumber, ip_id: newIpId.value, dates: { ...bill.dates, arrive: newDateArrive }, dokup: newDokupInfo } })
          close()
        }}
        >
          Сохранить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp >
  );
};

export default ChangeBillPopUp;
